import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import IconButton from 'components/icon-button'

import PlusIcon from '../../../../assets/icons/plus.svg'

import styles from './grid-header-corner.css'

const GridHeaderCorner = ({ style, showNewDatesModal }) => (
  <div style={style} styleName="cell">
    <div styleName="content" onClick={showNewDatesModal}>
      <IconButton label="Date">
        <PlusIcon />
      </IconButton>
    </div>
  </div>
)

GridHeaderCorner.propTypes = {
  style: PropTypes.object.isRequired,
  showNewDatesModal: PropTypes.func.isRequired,
}

export default CSSModules(GridHeaderCorner, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-header-corner/grid-header-corner.js
 **/